import { render, staticRenderFns } from "./EstimateSubHeader.vue?vue&type=template&id=4e4648fb&"
import script from "./EstimateSubHeader.vue?vue&type=script&lang=ts&"
export * from "./EstimateSubHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateSubHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports